import React, { useState, useEffect } from 'react';
import { Card, Table, Space, Button, Tooltip, message, Tabs } from 'antd';
import { EyeInvisibleOutlined, ReloadOutlined, EyeOutlined } from '@ant-design/icons';
import PageTitle from '../../components/PageTitle';

// 定义所有表格的列配置（宽度会根据用户调整自动更新）
const TABLE_COLUMNS_CONFIG = {
  userList: {
    name: '用户列表',
    storageKey: 'userList_columnStates',
    columns: [
      { key: 'id', title: 'ID', width: 70 },
      { key: 'real_name', title: '姓名', width: 100 },
      { key: 'nickname', title: '昵称', width: 100 },
      { key: 'phone', title: '手机号', width: 120 },
      { key: 'role', title: '角色', width: 200 },
      { key: 'status', title: '状态', width: 80 },
      { key: 'backup_real_name', title: '租客姓名', width: 100 },
      { key: 'backup_id_card', title: '租客身份证', width: 170 },
      { key: 'backup_idcard_front', title: '身份证正面', width: 90 },
      { key: 'backup_idcard_back', title: '身份证反面', width: 90 },
      { key: 'backup_checkin_status_text', title: '入住状态', width: 110 },
      { key: 'backup_identity_status_text', title: '实名状态', width: 130 },
      { key: 'openid', title: 'OpenID', width: 180 },
      { key: 'mp_openid', title: '公众号OpenID', width: 180 },
      { key: 'unionid', title: 'UnionID', width: 180 },
      { key: 'voice_notify', title: '语音提醒', width: 320 },
      { key: 'action', title: '操作', width: 140 },
    ],
  },
  orderList: {
    name: '订单列表',
    storageKey: 'orderList_columnStates',
    columns: [
      { key: 'id', title: '订单ID', width: 90 },
      { key: 'order_no', title: '订单号', width: 160 },
      { key: 'user_id', title: '用户ID', width: 80 },
      { key: 'user_phone', title: '租客手机号', width: 130 },
      { key: 'current_meter_no', title: '表号', width: 160 },
      { key: 'house_name', title: '房源名称', width: 130 },
      { key: 'room_fang_hao', title: '房间号', width: 100 },
      { key: 'room_id', title: '房间ID', width: 100 },
      { key: 'order_type', title: '订单类型', width: 120 },
      { key: 'order_amount', title: '订单金额', width: 100 },
      { key: 'electric_service_fee', title: '电表服务费', width: 120 },
      { key: 'water_service_fee', title: '水表服务费', width: 120 },
      { key: 'rent_service_fee', title: '租房服务费', width: 120 },
      { key: 'recharge_power', title: '充值度数', width: 90 },
      { key: 'meter_purchase_count', title: '购电次数', width: 92 },
      { key: 'order_status_text', title: '订单状态', width: 90 },
      { key: 'recharge_status_text', title: '充值状态', width: 90 },
      { key: 'after_meter_purchase_count', title: '充值后购电次数', width: 110 },
      { key: 'pay_channel_hf_seq_id', title: '汇付流水号', width: 180 },
      { key: 'before_power', title: '充值前剩余电量', width: 120 },
      { key: 'before_total_used', title: '充值前总用电量', width: 130 },
      { key: 'after_power', title: '充值后剩余电量', width: 120 },
      { key: 'pay_time', title: '支付时间', width: 150 },
      { key: 'landlord_fee', title: '房东分账金额', width: 120 },
      { key: 'company_fee', title: '公司分账金额', width: 120 },
      { key: 'shareholder_a_fee', title: '分账人A金额', width: 120 },
      { key: 'shareholder_b_fee', title: '分账人B金额', width: 120 },
      { key: 'shareholder_c_fee', title: '分账人C金额', width: 120 },
      { key: 'bank_fee', title: '银行手续费', width: 120 },
      { key: 'create_time', title: '创建时间', width: 150 },
      { key: 'action', title: '操作', width: 460 },
    ],
  },
  houseList: {
    name: '房源管理',
    storageKey: 'houseList_columnStates',
    columns: [
      { key: 'id', title: '房源ID', width: 70 },
      { key: 'name', title: '房源名称', width: 150 },
      { key: 'address', title: '详细地址', width: 250 },
      { key: 'landlordId', title: '房东ID', width: 80 },
      { key: 'landlordPhone', title: '房东手机号', width: 120 },
      { key: 'admins', title: '管理员', width: 180 },
      { key: 'createTime', title: '创建时间', width: 160 },
      { key: 'action', title: '操作', width: 200 },
    ],
  },
  roomList: {
    name: '房间管理',
    storageKey: 'roomList_columnStates',
    columns: [
      { key: 'id', title: '房间ID', width: 70 },
      { key: 'houseName', title: '所属房源', width: 150 },
      { key: 'houseId', title: '所属房源ID', width: 80 },
      { key: 'number', title: '房间号', width: 90 },
      { key: 'roomAddress', title: '房间地址', width: 140 },
      { key: 'floor', title: '楼层', width: 70 },
      { key: 'price', title: '租金(元/月)', width: 100 },
      { key: 'deposit', title: '押金(元)', width: 90 },
      { key: 'tenantId', title: '租客ID', width: 80 },
      { key: 'tenantPhone', title: '租客手机号', width: 120 },
      { key: 'status', title: '状态', width: 80 },
      { key: 'createTime', title: '创建时间', width: 160 },
      { key: 'action', title: '操作', width: 140 },
    ],
  },
  billList: {
    name: '账单管理',
    storageKey: 'billList_columnStates',
    columns: [
      { key: 'mpNotify', title: '公众号提醒', width: 200 },
      { key: 'houseId', title: '房源ID', width: 80 },
      { key: 'roomId', title: '房间ID', width: 80 },
      { key: 'houseName', title: '房源名称', width: 130 },
      { key: 'roomNumber', title: '房间号', width: 100 },
      { key: 'billId', title: '账单ID', width: 80 },
      { key: 'tenantId', title: '租客ID', width: 80 },
      { key: 'tenantPhone', title: '租客手机号', width: 120 },
      { key: 'totalAmount', title: '账单总金额', width: 100 },
      { key: 'status', title: '状态', width: 80 },
      { key: 'pay_source', title: '支付来源', width: 180 },
      { key: 'createTime', title: '创建时间', width: 160 },
      { key: 'action', title: '操作', width: 280 },
    ],
  },
  electricMeterList: {
    name: '电表管理',
    storageKey: 'electricMeterList_columnStates',
    columns: [
      { key: 'action', title: '操作', width: 200 },
      { key: 'id', title: '电表ID', width: 70 },
      { key: 'device_mac', title: '设备MAC', width: 140 },
      { key: 'factory_meter_no', title: '厂商表号', width: 130 },
      { key: 'latest_rx_topic', title: '最新RX主题', width: 200 },
      { key: 'current_meter_no', title: '当前表号', width: 130 },
      { key: 'communication_type', title: '通讯类型', width: 100 },
      { key: 'is_online_name', title: '在线状态', width: 100 },
      { key: 'iccid', title: 'ICCID', width: 200 },
      { key: 'signal_rssi', title: '信号强度', width: 90 },
      { key: 'signal_strength_bars', title: '信号强度(换算)', width: 110 },
      { key: 'last_signal_at', title: '上次信号时间', width: 170 },
      { key: 'last_electric_pay_at', title: '上次充值时间', width: 170 },
      { key: 'manufacturer', title: '设备厂家', width: 140 },
      { key: 'imei', title: 'IMEI', width: 160 },
      { key: 'device_detail_type', title: '设备详细类型', width: 120 },
      { key: 'device_status_name', title: '设备状态', width: 90 },
      { key: 'electric_balance', title: '电表余额(元)', width: 100 },
      { key: 'electric_quantity', title: '剩余电量(kWh)', width: 110 },
      { key: 'min_recharge', title: '最低充值(元)', width: 100 },
      { key: 'management_fee', title: '管理费(元)', width: 100 },
      { key: 'total_electricity', title: '总用电量(kWh)', width: 110 },
      { key: 'electric_price', title: '电价(元/kWh)', width: 100 },
      { key: 'room_name', title: '绑定房间', width: 100 },
      { key: 'house_name', title: '所属房源', width: 150 },
      { key: 'created_at', title: '创建时间', width: 160 },
      { key: 'updated_at', title: '更新时间', width: 160 },
      { key: 'delete_action', title: '删除', width: 88 },
    ],
  },
  waterMeterList: {
    name: '水表管理',
    storageKey: 'waterMeterList_columnStates',
    columns: [
      { key: 'action', title: '操作', width: 400 },
      { key: 'id', title: '水表ID', width: 70 },
      { key: 'device_mac', title: '设备MAC', width: 140 },
      { key: 'factory_meter_no', title: '厂商表号', width: 130 },
      { key: 'current_meter_no', title: '当前表号', width: 130 },
      { key: 'imei', title: 'IMEI', width: 160 },
      { key: 'communication_type', title: '通讯类型', width: 100 },
      { key: 'is_online_name', title: '在线状态', width: 100 },
      { key: 'device_detail_type', title: '设备详细类型', width: 120 },
      { key: 'manufacturer', title: '设备厂家', width: 140 },
      { key: 'device_status_name', title: '设备状态', width: 90 },
      { key: 'electric_balance', title: '水表余额(元)', width: 100 },
      { key: 'electric_quantity', title: '剩余水量(吨)', width: 110 },
      { key: 'min_recharge', title: '最低充值(元)', width: 100 },
      { key: 'management_fee', title: '管理费(元)', width: 100 },
      { key: 'total_water_quantity', title: '总用水量(吨)', width: 110 },
      { key: 'water_price', title: '水价(元/吨)', width: 100 },
      { key: 'room_name', title: '绑定房间', width: 100 },
      { key: 'house_name', title: '所属房源', width: 150 },
      { key: 'created_at', title: '创建时间', width: 160 },
      { key: 'updated_at', title: '更新时间', width: 160 },
      { key: 'delete_action', title: '删除', width: 88 },
    ],
  },
  lockList: {
    name: '门锁管理',
    storageKey: 'lockList_columnStates',
    columns: [
      { key: 'action', title: '操作', width: 80 },
      { key: 'id', title: '门锁ID', width: 70 },
      { key: 'device_mac', title: '设备MAC', width: 140 },
      { key: 'factory_meter_no', title: '厂商编号', width: 130 },
      { key: 'current_meter_no', title: '当前编号', width: 130 },
      { key: 'lock_reviewed', title: '是否审核', width: 88 },
      { key: 'lock_source', title: '来源', width: 88 },
      { key: 'communication_type', title: '通讯类型', width: 100 },
      { key: 'is_online_name', title: '在线状态', width: 100 },
      { key: 'device_detail_type', title: '设备详细种类', width: 130 },
      { key: 'lock_battery', title: '门锁电量', width: 100 },
      { key: 'manufacturer', title: '设备厂家', width: 140 },
      { key: 'imei', title: 'IMEI', width: 160 },
      { key: 'iccid', title: 'ICCID', width: 200 },
      { key: 'device_status_name', title: '设备状态', width: 90 },
      { key: 'min_recharge', title: '最低充值(元)', width: 100 },
      { key: 'management_fee', title: '管理费(元)', width: 100 },
      { key: 'room_name', title: '绑定房间', width: 100 },
      { key: 'house_name', title: '所属房源', width: 150 },
      { key: 'created_at', title: '创建时间', width: 160 },
      { key: 'updated_at', title: '更新时间', width: 160 },
      { key: 'delete_action', title: '删除', width: 88 },
    ],
  },
  huifuAccountList: {
    name: '汇付账号管理',
    storageKey: 'huifuAccountList_columnStates',
    columns: [
      { key: 'id', title: 'ID', width: 80 },
      { key: 'user_id', title: '用户ID', width: 100 },
      { key: 'real_name', title: '真实姓名', width: 120 },
      { key: 'phone', title: '手机号', width: 130 },
      { key: 'id_card', title: '身份证号', width: 180 },
      { key: 'cert_validity_type', title: '证件有效期类型', width: 140 },
      { key: 'cert_begin_date', title: '证件有效期开始日期', width: 160 },
      { key: 'cert_end_date', title: '证件有效期截止日期', width: 160 },
      { key: 'huifu_id', title: '汇付ID', width: 150 },
      { key: 'status', title: '状态', width: 80 },
      { key: 'created_at', title: '创建时间', width: 160 },
      { key: 'updated_at', title: '更新时间', width: 160 },
      { key: 'action', title: '操作', width: 150 },
    ],
  },
  huifuBankCardList: {
    name: '汇付银行卡管理',
    storageKey: 'huifuBankCardList_columnStates',
    columns: [
      { key: 'id', title: 'ID', width: 80 },
      { key: 'user_id', title: '用户ID', width: 100 },
      { key: 'bank_name', title: '银行名称', width: 150 },
      { key: 'bank_account_name', title: '开户名', width: 120 },
      { key: 'bank_account_no', title: '银行卡号', width: 200 },
      { key: 'bank_code', title: '银行编码', width: 120 },
      { key: 'province_name', title: '省', width: 120 },
      { key: 'city_name', title: '市', width: 120 },
      { key: 'prov_id', title: '省份代码', width: 100 },
      { key: 'area_id', title: '城市代码', width: 100 },
      { key: 'is_default', title: '是否默认', width: 100 },
      { key: 'card_status', title: '银行卡状态', width: 120 },
      { key: 'created_at', title: '创建时间', width: 160 },
      { key: 'updated_at', title: '更新时间', width: 160 },
      { key: 'action', title: '操作', width: 150 },
    ],
  },
  operationLogListElectric: {
    name: '电表操作记录',
    storageKey: 'operationLogList_electric_columnStates',
    columns: [
      { key: 'create_time', title: '操作时间', width: 170 },
      { key: 'device_id', title: '设备ID', width: 100 },
      { key: 'current_meter_no', title: '表号', width: 140 },
      { key: 'meter_no', title: '日志表号', width: 140 },
      { key: 'house_name', title: '房源', width: 140 },
      { key: 'room_fang_hao', title: '房号', width: 100 },
      { key: 'operation', title: '操作类型', width: 120 },
      { key: 'content', title: '操作内容', width: 200 },
      { key: 'operator', title: '操作人', width: 160 },
      { key: 'status_text', title: '状态', width: 90 },
    ],
  },
  operationLogListWater: {
    name: '水表操作记录',
    storageKey: 'operationLogList_water_columnStates',
    columns: [
      { key: 'create_time', title: '操作时间', width: 170 },
      { key: 'device_id', title: '设备ID', width: 100 },
      { key: 'current_meter_no', title: '表号', width: 140 },
      { key: 'meter_no', title: '日志表号', width: 140 },
      { key: 'house_name', title: '房源', width: 140 },
      { key: 'room_fang_hao', title: '房号', width: 100 },
      { key: 'operation', title: '操作类型', width: 120 },
      { key: 'content', title: '操作内容', width: 200 },
      { key: 'operator', title: '操作人', width: 160 },
      { key: 'status_text', title: '状态', width: 90 },
    ],
  },
  operationLogListLock: {
    name: '门锁操作记录',
    storageKey: 'operationLogList_lock_columnStates',
    columns: [
      { key: 'create_time', title: '操作时间', width: 170 },
      { key: 'device_id', title: '设备ID', width: 100 },
      { key: 'current_meter_no', title: '表号', width: 140 },
      { key: 'house_name', title: '房源', width: 140 },
      { key: 'room_fang_hao', title: '房号', width: 100 },
      { key: 'method_text', title: '开锁方式', width: 120 },
      { key: 'user_type', title: '开锁人身份', width: 100 },
      { key: 'operator_phone', title: '操作人', width: 140 },
      { key: 'success_text', title: '结果', width: 90 },
    ],
  },
  splitConfigHouseList: {
    name: '分账管理-房源分账配置',
    storageKey: 'splitConfigHouseList_columnStates',
    columns: [
      { key: 'id', title: '房源ID', width: 100 },
      { key: 'house_name', title: '房源名称', width: 200 },
      { key: 'address', title: '地址', width: 250 },
      { key: 'landlord_rent_split_rate', title: '房东房租分账比例', width: 140 },
      { key: 'landlord_electric_split_rate', title: '房东电费分账比例', width: 140 },
      { key: 'landlord_water_split_rate', title: '房东水费分账比例', width: 140 },
      { key: 'service_fee_rate', title: '租房服务费比例', width: 130 },
      { key: 'electric_service_fee_rate', title: '电表服务费费率', width: 130 },
      { key: 'water_service_fee_rate', title: '水表服务费费率', width: 130 },
      { key: 'rent_company_rate', title: '租房公司比例', width: 120 },
      { key: 'service_fee_rate_p3', title: '租房分账人A比例', width: 120 },
      { key: 'service_fee_rate_p4', title: '租房分账人B比例', width: 120 },
      { key: 'service_fee_rate_p5', title: '租房分账人C比例', width: 120 },
      { key: 'service_fee_rate_p6', title: '租房银行手续费比例', width: 140 },
      { key: 'electric_company_rate', title: '电表公司比例', width: 120 },
      { key: 'electric_service_fee_rate_p3', title: '电表分账人A比例', width: 120 },
      { key: 'electric_service_fee_rate_p4', title: '电表分账人B比例', width: 120 },
      { key: 'electric_service_fee_rate_p5', title: '电表分账人C比例', width: 120 },
      { key: 'electric_service_fee_rate_p6', title: '电表银行手续费比例', width: 140 },
      { key: 'water_company_rate', title: '水表公司比例', width: 120 },
      { key: 'water_service_fee_rate_p3', title: '水表分账人A比例', width: 120 },
      { key: 'water_service_fee_rate_p4', title: '水表分账人B比例', width: 120 },
      { key: 'water_service_fee_rate_p5', title: '水表分账人C比例', width: 120 },
      { key: 'water_service_fee_rate_p6', title: '水表银行手续费比例', width: 140 },
    ],
  },
};

const SettingColumns = () => {
  const [columnStates, setColumnStates] = useState({});
  const [refreshKey, setRefreshKey] = useState(0); // 用于触发重新渲染

  // 从localStorage加载所有表格的列状态
  useEffect(() => {
    const states = {};
    Object.keys(TABLE_COLUMNS_CONFIG).forEach(tableKey => {
      const storageKey = TABLE_COLUMNS_CONFIG[tableKey].storageKey;
      const saved = localStorage.getItem(storageKey);
      if (saved) {
        try {
          states[tableKey] = JSON.parse(saved);
        } catch (e) {
          console.error(`Failed to parse column states for ${tableKey}:`, e);
        }
      }
    });
    setColumnStates(states);
  }, []);

  // 切换列隐藏状态
  const toggleColumnVisibility = (tableKey, columnKey) => {
    setColumnStates(prev => {
      const newStates = { ...prev };
      if (!newStates[tableKey]) {
        newStates[tableKey] = {};
      }
      // 切换隐藏状态：如果当前是hidden，则设为visible（不设置），否则设为hidden
      if (newStates[tableKey][columnKey] === 'hidden') {
        delete newStates[tableKey][columnKey];
      } else {
        newStates[tableKey][columnKey] = 'hidden';
      }
      
      // 保存到localStorage
      const storageKey = TABLE_COLUMNS_CONFIG[tableKey].storageKey;
      localStorage.setItem(storageKey, JSON.stringify(newStates[tableKey]));
      
      message.success(newStates[tableKey][columnKey] === 'hidden' ? '已隐藏该列' : '已显示该列');
      return newStates;
    });
  };

  // 重置某个表格的所有列设置
  const resetTableColumns = (tableKey) => {
    const newStates = { ...columnStates };
    delete newStates[tableKey];
    setColumnStates(newStates);
    
    const storageKey = TABLE_COLUMNS_CONFIG[tableKey].storageKey;
    localStorage.removeItem(storageKey);
    message.success('已重置列设置');
  };

  // 生成表格列配置
  const getTableColumns = (tableKey) => {
    const config = TABLE_COLUMNS_CONFIG[tableKey];
    const states = columnStates[tableKey] || {};
    
    return [
      {
        title: '列名',
        dataIndex: 'title',
        key: 'title',
        width: 200,
      },
      {
        title: '操作',
        key: 'action',
        width: 150,
        render: (_, record) => {
          const isHidden = states[record.key] === 'hidden';
          return (
            <Space size="small">
              <Button
                type={isHidden ? 'default' : 'primary'}
                danger={isHidden}
                size="small"
                icon={isHidden ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                onClick={() => toggleColumnVisibility(tableKey, record.key)}
              >
                {isHidden ? '显示' : '隐藏'}
              </Button>
            </Space>
          );
        },
      },
    ];
  };

  // 生成Tab项
  const tabItems = Object.keys(TABLE_COLUMNS_CONFIG).map(tableKey => {
    const config = TABLE_COLUMNS_CONFIG[tableKey];
    return {
      key: tableKey,
      label: config.name,
      children: (
        <div>
          <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ color: '#666', fontSize: 11 }}>
              设置该表格各列的显示/隐藏。列宽可在表格页面直接拖动调整，调整后的宽度会自动保存。
            </span>
            <Button
              icon={<ReloadOutlined />}
              size="small"
              onClick={() => resetTableColumns(tableKey)}
            >
              重置隐藏设置
            </Button>
          </div>
          <Table
            columns={getTableColumns(tableKey)}
            dataSource={config.columns}
            rowKey="key"
            pagination={false}
            size="small"
          />
        </div>
      ),
    };
  });

  return (
    <div>
      <PageTitle title="列设置" />
      <Card>
        <Tabs items={tabItems} />
      </Card>
    </div>
  );
};

export default SettingColumns;

